<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { AppBreadcrumbs } from '~/components/base';
import { AppTopbar } from '~/components/layout';

const route = useRoute();

useHead({
  bodyAttrs: {
    class: 'bg-[#f1f5f9] h-full',
  },
});

const showBreadcrumbs = computed((): boolean => {
  return !['auth-onboarding'].includes(route.name as string);
});

const breadcrumbs = computed(() => {
  const routeName = route.name as string;

  if (routeName === 'auth-delete-account') {
    return [
      {
        label: 'Account Settings',
        to: '/auth/account-settings/login-and-security',
      },
      { label: 'Delete Account' },
    ];
  }

  if (routeName === 'auth-change-password') {
    return [
      {
        label: 'Account Settings',
        to: '/auth/account-settings/login-and-security',
      },
      { label: 'Change Password' },
    ];
  }

  return [];
});
</script>

<template>
  <div class="empty-layout relative min-h-screen w-full">
    <AppTopbar mode="simple" />
    <div
      class="empty-layout__content mx-auto h-full w-full max-w-[996px] px-4 lg:px-0"
    >
      <AppBreadcrumbs
        v-if="showBreadcrumbs"
        class="mt-5"
        :include-home="false"
        :custom-breadcrumbs="breadcrumbs"
      />
      <NuxtPage :page-key="(route) => route.fullPath" />
    </div>
  </div>
</template>
